import React from 'react';

import LoadingSpinner from 'Core/Components/LoadingSpinner';

class LoadingView extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { style } = this.props;
    return (
      <div className="LoadingView" style={style ? style : {}}>
        <img src="assets/logo-black.svg" className="Main-Logo" />
        <p>
          <br />
          <LoadingSpinner/>
        </p>
      </div>
    );
  }
};

export default LoadingView;



// WEBPACK FOOTER //
// ./client/Core/Status/LoadingView.jsx